import * as React from 'react';
import { BFFWebChatContext } from '../../context/BFFWebChatContext';
export function useBFFWebChatState() {
    const context = React.useContext(BFFWebChatContext);
    if (context === undefined) {
        throw new Error('useBFFWebChatState must be used within a BFFWebChatContextProvider');
    }
    return [context.state, context.dispatch];
}
//# sourceMappingURL=useBFFWebChatState.js.map